/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { ThemeProvider } from "styled-components"
import trevTheme from "../themes/trevTheme"

// Import Stylesheets
import "normalize.css"
import "../css/main.css"

// Import Common Components
import { Footer, Header } from "./nav"

// Styles
const PageWrapper = styled.main`
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
`
//Removed until further notice
// const CookieModal = () => {
//   const location = useLocation()
//   return (
//     <CookieConsent
//       location="bottom"
//       buttonText="Accept"
//       declineButtonText="Decline"
//       onAccept={() => {
//         Cookies.set("gatsby-gdpr-google-analytics", "true")
//         Cookies.set("gatsby-gdpr-google-tagmanager", "true")
//         initializeAndTrack(location)
//       }}
//       style={{
//         background: "#2B373B",
//         textAlign: "center",
//         padding: "0 3vw",
//         alignItems: "center",
//         justifyContent: "center",
//       }}
//     >
//       We use cookies to give you the best experience on our website. By
//       continuing to browse, you agree to us using cookies. To find out more
//       please visit our Cookie Statement and our Privacy Statement.
//     </CookieConsent>
//   )
// }

const Layout = ({ children, $reverseHeader = false }) => {
  return (
    <ThemeProvider theme={trevTheme}>
      <Header $reverseHeader={$reverseHeader} />
      <PageWrapper>
        {children}
        {/* <CookieModal /> */}
        <Footer />
      </PageWrapper>
    </ThemeProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
